import { Button, ButtonFullProps } from '../Button/Button'
import React from 'react'
import styled, { css, StyledProps } from 'styled-components'
import { IconArrowBack } from '../../iconography/Icons/Icons'

type Size = 'big' | 'medium' | 'small'
type ButtonProps = StyledProps<{ size?: Size }>
const ButtonStyled = styled(Button)<ButtonProps>`
  ${(props: ButtonProps) => {
    let width = ''
    switch (props.size) {
      case 'big':
        width = '48px'
        break
      case 'medium':
        width = '40px'
        break
      case 'small':
        width = '32px'
        break
    }

    return css`
      max-width: ${width};
      min-width: ${width}; // just override Button component min-width
      padding: 0 10px;
    `
  }}
`

export const BackButton: React.FC<{ onClick(): void; size?: Size } & Partial<ButtonFullProps>> = ({
  onClick,
  size = 'medium',
}) => {
  return (
    <ButtonStyled onClick={onClick} intent={'cancel'} size={size}>
      <IconArrowBack />
    </ButtonStyled>
  )
}
